<template>
  <artmisads-modal v-model:open="open" title="Edit Tags" :width="400" 
    :destroyOnClose="true" :footer="null">
    <div class="content">
      <div class="form-item">
        <label>标签1:</label>
        <artmisads-input v-model:value="tags.tag1" style="width: 100%" />
      </div>
      <div class="form-item">
        <label>标签2:</label>
        <artmisads-input v-model:value="tags.tag2" style="width: 100%" />
      </div>
      <div class="form-item">
        <label>标签3:</label>
        <artmisads-input v-model:value="tags.tag3" style="width: 100%" />
      </div>
      <div class="form-item">
        <label>标签4:</label>
        <artmisads-input v-model:value="tags.tag4" style="width: 100%" />
      </div>
      <div class="form-item">
        <label>标签5:</label>
        <artmisads-input v-model:value="tags.tag5" style="width: 100%" />
      </div>
      <div class="footer">
        <artmisads-button type="primary" @click="save">Save</artmisads-button>
      </div>
    </div>
   </artmisads-modal>
</template>   
<script setup >
import { ref,defineExpose } from 'vue'
import { message } from 'ant-design-vue';

import { publisherAdminApi } from '~/server/index'
const emit = defineEmits(['refresh']);
const open = ref(false)
const publisherObj=ref({})
const tags = ref({
  tag1: '',
  tag2: '',
  tag3: '',
  tag4: '',
  tag5: ''
})

const showModal=(obj)=>{
  open.value=true
  publisherObj.value=obj
  tags.value=JSON.parse(JSON.stringify(obj?.tags || {}))
  // console.log(publisherObj.value,'publisherObj.value');
}

const save = async() => {
  const param={
    publisherId: publisherObj.value.id,
    tags: JSON.stringify(tags.value),
    bd: publisherObj.value.bd,
    referral: publisherObj.value.referral,
  }
 const res = await publisherAdminApi.setPublisherTags(param)
 if(res.success){
  open.value = false
  message.success('Save Success')
  emit('refresh')
 }else{
  message.error(res.error || 'Save failed')
 }

  
  // 这里可以添加保存逻辑
}

defineExpose({
  showModal
})
</script>
<style scoped>
.content{
  padding: 20px;
}

.form-item{
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}

.form-item label{
  width: 60px;
  margin-right: 12px;
  font-weight: 500;
}

.footer{
  margin-top: 24px;
  display: flex;
  justify-content: center;
}
</style>
